<template>
  <div class="header">
    <!-- <HeaderSiteController /> -->
    <div class="header__single">
      <template v-if="admin">
        <div class="header__single-text">{{ $t("header.queue") }}</div>
        <div @click="toggleQueue" :class="['header__single-switch', queue && 'active']"></div>
      </template>
    </div>
    <HeaderUser />
    <MainModal
      v-if="modal"
      class="modal-accesses"
      :on-close="handleCloseAccessesModal"
      :modal-center="true"
    >
      <div class="list__confirm">
        <div v-if="queue" class="list__confirm-title">{{ $t("header.queueDisable") }}</div>
        <div v-if="!queue" class="list__confirm-title">{{ $t("header.queueEnable") }}</div>

        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="toggleQueue">{{ $t("common.yes") }}</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleCloseAccessesModal" :button-cancel="true">{{
              $t("common.no")
            }}</MainButton>
          </div>
        </div>
      </div>
    </MainModal>
    <FetchSpinnerModal v-if="loadingProcess" />
  </div>
</template>

<script>
// import HeaderSiteController from "./HeaderSiteController.vue";
import HeaderUser from "./HeaderUser.vue";
import MainModal from "../../components/molecules/MainModal.vue";
import MainButton from "../../components/atoms/buttons/MainButton.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import { mapState } from "vuex";
import { getStoredUserInfo } from "~/helpers/userAuth";

import leadApi from "~/api/lead";

export default {
  name: "Header",
  data() {
    return {
      modal: false,
      loadingProcess: false,

      admin: false,
      team_lead: false,
      bayer: false,
      af_manager: false,
    };
  },
  components: {
    // HeaderSiteController,
    HeaderUser,
    MainModal,
    MainButton,
    FetchSpinnerModal,
  },
  computed: {
    ...mapState("users", ["errorAuth"]),
    ...mapState("lead", ["queue"]),
  },
  mounted() {
    this.getQueue();

    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
      if (
        this.user.groups[0].id == 2 ||
        this.user.groups[0].id == 6 ||
        this.user.groups[0].id == 5
      ) {
        this.admin = true;
      } else if (this.user.groups[0].id == 4) {
        this.team_lead = true;
      } else if (this.user.groups[0].id == 3) {
        this.bayer = true;
      } else if (this.user.groups[0].id == 7) {
        this.af_manager = true;
      }
    }
  },

  methods: {
    handleCloseAccessesModal() {
      this.modal = false;
    },
    handleGoToLogin() {
      this.$store.dispatch("users/logout");
      this.$router.push("/login");
    },
    handleModal() {
      this.modal = true;
      console.log("hello");
    },
    async getQueue() {
      this.loadingProcess = true;
      await leadApi
        .getQueue()
        .then((res) => {
          this.$store.commit("lead/setQueue", res.data.queueMode);
          this.loadingProcess = false;
          this.modal = false;
        })
        .catch((error) => {
          this.loadingProcess = false;
        })
        .finally(() => {});
    },
    async toggleQueue() {
      this.loadingProcess = true;

      const data = {};
      data.is_active = !this.queue;

      await leadApi
        .putQueue(data)
        .then((res) => {
          this.getQueue();
          this.loadingProcess = false;
        })
        .catch((error) => {
          this.loadingProcess = false;
        })
        .finally(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px;
  background: $coffee;

  &__single-text {
    color: #fff;
    margin-right: 10px;
  }

  &__site-choose {
    color: $g-color-white;
    font-weight: bold;
  }

  &__site-list {
    list-style: none;
  }

  &__single {
    margin-left: auto;
    padding-right: 30px;
    display: flex;
    align-items: center;
  }

  &__single-switch {
    width: 60px;
    height: 30px;
    border-radius: 50px;
    background: red;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 5px;
    cursor: pointer;

    &.active {
      background: green;
      justify-content: flex-end;
    }

    &::before {
      content: "";
      width: 20px;
      height: 20px;
      border-radius: 50px;
      background: #fff;
    }
  }
}
</style>
